import { WSIcons } from "../../commonFunctions/iIcons";

export const getMenu: any = (userType: string) => {
  const adminMenu = [
  {
    id: 1,
    label: "Dashboard",
    icon: WSIcons.Home,
    path: "/dashboard"
  },
  {
    id: 2,
    label: "Estimates",
    icon: WSIcons.Pencil,
    path: "/estimates"
  },
  {
    id: 2.1,
    label: "Quotations",
    icon: WSIcons.Quote,
    path: "/quotations"
  },
  {
    id: 3,
    label: "Rate Cards",
    icon: WSIcons.Cards,
    path: "/ratecards"
  },
  {
    id: 4,
    label: "Clients",
    icon: WSIcons.Users,
    path: "/clients"
  },
  {
    id: 5,
    label: "Employees",
    icon: WSIcons.Work,
    path: "/employees/list"
  },
  {
    id: 6,
    label: "Templates",
    icon: WSIcons.Template,
    path: "/templates"
  },
  {
    id:7,
    label:"Registration",
    icon:WSIcons.LockIcon,
    path:'/registration'
  },
  {
    id:8,
    label:"Settings",
    icon:WSIcons.SettingsIcon,
    path:'/settings'
  }
  // {
  //   id: 6,
  //   label: "Masters",
  //   icon: WSIcons.Masters,
  //   children: [
  //     { id: 61, label: "Banners", path: "/masters/banner" },
  //     { id: 62, label: "Tax Settings", path: "/masters/taxes" },
  //     { id: 63, label: "Units", path: "/masters/units" }
  //   ]
  // },
  // {
  //   id: 7,
  //   label: "Team Management",
  //   icon: WSIcons.Users,
  //   path: "/team"
  // },
  // {
  //   id: 8,
  //   label: "Settings",
  //   icon: WSIcons.SettingsIcon,
  //   children: [
  //     { id: 81, label: "Organization", path: "/organization/view" },
  //     { id: 82, label: "Change Password", path: "/changepassword" }
  //   ]
  // },
];


  const employeeMenu = [
  {
    id: 1,
    label: "Estimates",
    icon: WSIcons.Pencil,
    path: "/estimates"
  },
  {
    id: 2,
    label: "Leave Request",
    icon: WSIcons.Leave,
    path: "/leave/request"
  },
  {
    id: 3,
    label: "Templates",
    icon: WSIcons.Template,
    path: "/templates"
  },
  {
    id: 4,
    label: "Settings",
    icon: WSIcons.SettingsIcon,
    path: "/settings"
  }
];


  const projectManagerMenu = [
  {
    id: 1,
    label: "Dashboard",
    icon: WSIcons.Home,
    path: "/dashboard"
  },
  {
    id: 2,
    label: "Estimates",
    icon: WSIcons.Pencil,
    path: "/estimates"
  },
  {
    id: 2.1,
    label: "Quotations",
    icon: WSIcons.Quote,
    path: "/estimates"
  },
  {
    id: 3,
    label: "Rate Cards",
    icon: WSIcons.Cards,
    path: "/ratecards"
  },
  {
    id: 4,
    label: "Clients",
    icon: WSIcons.Users,
    path: "/clients"
  },
  {
    id: 5,
    label: "Templates",
    icon: WSIcons.Template,
    path: "/templates"
  },
  {
    id: 6,
    label: "Reports",
    icon: WSIcons.Report,
    path: "/reports"
  },
  {
    id: 7,
    label: "Change Password",
    icon: WSIcons.SettingsIcon,
    path: "/changepassword"
  },
  {
    id:8,
    label:"Settings",
    icon:WSIcons.SettingsIcon,
    path:'/settings'
  }
];


  // Return based on role
  switch (userType) {
    case "admin":
      return { staticMenu: adminMenu };
    case "employee":
      return { staticMenu: employeeMenu };
    case "project_manager":
      return { staticMenu: projectManagerMenu };
    default:
      return { staticMenu: [] };
  }
};
